// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoField[data-v-21b55fc4]{line-height:2em}.infoField .infoLabel[data-v-21b55fc4]{vertical-align:middle;display:inline-block;width:150px}", ""]);
// Exports
module.exports = exports;
